//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            tableLoading: false,
            tableData: [],
            pagination: {},
            tableSorting: ''
        };
    },

    computed: {
        params: function () {
            let params = {};

            if (this.tableSorting !== '' && this.tableSorting !== 'null|asc') {
                params.sort = this.tableSorting;
            }

            params.limit = this.pagination.perPage;
            params.page = this.pagination.currentPage;

            params.with = ['creator'];

            return params;
        }
    },

    mounted () {
        this.loadData();
    },

    methods: {
        loadData () {
            this.tableLoading = true;

            axios.get('whitelisted-emails', {
                params: this.params
            })
                .then(response => {
                    this.tableData = response.data.data;
                    this.pagination = this.$helper.getPaginationData(response);
                })
                .catch(error => {
                    console.log(error);
                })
                .then(() => {
                    this.tableLoading = false;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        goToPage (page) {
            this.pagination.currentPage = page;
            this.loadData();
        },

        handleTableSort (data) {
            let order = 'asc';

            if (data.order === 'descending') {
                order = 'desc';
            }

            this.tableSorting = data.prop + '|' + order;
            this.loadData();
        },

        handleCreateWhitelistedEmail () {
            this.$refs['emailForm'].setItem(false);
            this.$refs['emailForm'].show();
        },

        handleEditWhitelistedEmail (row) {
            this.$refs['emailForm'].setItem(row);
            this.$refs['emailForm'].show();
        },

        handleConfirmDelete: function (row) {
            this.$confirm(this.$lang.get('models.email.delete.text'), this.$lang.get('models.email.delete.confirm'), {
                confirmButtonText: this.$lang.get('std.delete'),
                cancelButtonText: this.$lang.get('std.cancel'),
                type: 'warning'
            }).then(() => {
                this.handleDeleteWhitelistedEmail(row);
            }).catch(error => {
                console.log(error);
            });
        },

        handleDeleteWhitelistedEmail: function (row) {
            axios.delete('whitelisted-emails/' + row.id)
                .then(response => {
                    this.loadData();
                    this.$message({
                        type: 'success',
                        message: response.data.message
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        },

        showImportEmailsDialog () {
            this.$refs['emailImportForm'].show();
        },

        exportEmails () {
            window.open(
                '/whitelisted-emails/export',
                '_blank'
            );
        },
    }
};
